// @ts-nocheck
import {
  Fragment,
  useEffect,
  useRef,
  useState,
  Ref,
  useMemo,
  useCallback,
} from "react";
import Image from "src/components/image";

import { GLB_AVATAR } from "src/const/navigationConst";
import { AMPLITUDE_EVENT, EVENT, trackGAEvent } from "@/utils/analytics";
import { trackEvent } from "@/amplitudeClient";
// import {
//   VenueModelConfig,
//   getVenueModelConfig,
//   getAltitudeByFloorIndex,
//   getFloorNameByFloorIndex,
//   getAltitudeByFloorName,
//   getFloorIndexByFloorName,
// } from "src/const/venue_model/venue_model_config";

import {
  VenueModelConfig,
  getVenueModelConfigByVenueCode,
  getVenueIdByVenueCode,
  getAltitudeByFloorIndex,
  getFloorNameByFloorIndex,
  getAltitudeByFloorName,
  getFloorIndexByFloorName,
  getBaseUrl,
  getVenueNameByVenueCode,
} from "src/utils/map-util";

import { useExplorationStore } from "@/store/explorationStore";

import { initCameraMovement } from "src/const/explorationConst";

import {
  interpolateVector3,
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  wrapAngle,
  tri,
} from "src/utils/game";
import * as pc from "playcanvas";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
  useAppEvent,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
} from "@playcanvas/react/components";
import { Texture } from "@playcanvas/engine"; // For texture loading

import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";

import WatermarkScreen from "src/components/watermark";
import { useLodSplat } from "src/utils/useLodSplat";

import Lottie from "lottie-react";
import loading from "src/components/lottie/loading.json";

import { GsplatRevealRadial } from "src/extra_js/reveal-radial.mjs";

export default function ExploreIndoorPage() {
  const setCameraPosition = useExplorationStore(
    (state) => state.setCameraPosition,
  );
  const setCameraLookingPosition = useExplorationStore(
    (state) => state.setCameraLookingPosition,
  );
  const setCameraAngle = useExplorationStore((state) => state.setCameraAngle);
  const setCurrentVenueName = useExplorationStore(
    (state) => state.setCurrentVenueName,
  );
  const setCurrentLevel = useExplorationStore((state) => state.setCurrentLevel);
  const setCurrentLevelIndex = useExplorationStore(
    (state) => state.setCurrentLevelIndex,
  );

  const setExploratingPosition = useExplorationStore(
    (state) => state.setExploratingPosition,
  );
  const setExploratingAngle = useExplorationStore(
    (state) => state.setExploratingAngle,
  );
  const setIsDisplayUI = useExplorationStore((state) => state.setIsDisplayUI);
  const enableXRayMode = useExplorationStore((state) => state.enableXRayMode);

  const [venueModelConfigState, setVenueModelConfigState] = useState<number>(0);
  const [modelScaleFactorState, setModelScaleFactorState] =
    useState<number>(0.1);

  const gsplatMainRef = useRef();

  const moveSpeedRef = useRef<number>(1);
  const rotateSpeedRef = useRef<number>(1);
  const downSpeedRef = useRef<number>(1);

  const topPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const downPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const backPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

  const targetAltitudeRef = useRef<number>(0);

  const latestCurrentLevelNameRef = useRef<string>("");
  const isLevelChangingRef = useRef<boolean>(false);

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const hiddenNearRef = useRef<pc.Entity>(null);
  const hiddenFarRef = useRef<pc.Entity>(null);
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestCameraModeRef = useRef<number>(0);
  const latestXrayModeRef = useRef<number>(0);

  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const revealEffectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const [modelLoadedState, setModelLoadedState] = useState(false);
  const [coordReadyState, setCoordReadyState] = useState(false);

  const startPosRef = useRef(new pc.Vec3());
  const endPosRef = useRef(new pc.Vec3());

  const [startTransition, setStartTransition] = useState(false);

  const currentFloorRef = useRef("-1");
  const toggleResetRef = useRef(false);

  // const controls = useRef<any>(null);
  // const navigationObject = useRef<Group | null>(null);
  // const firstPersonCameraVector = useRef<Group | null>(null);
  // const thirdPersonCameraVector = useRef<Group | null>(null);

  const isMovingRef = useRef<boolean>(false);
  const isRotatingRef = useRef<boolean>(false);

  const latestPositionJoystickData = useRef<number[]>([0, 0]);
  const latestRotationJoystickData = useRef<number[]>([0, 0]);
  const latestRotationScreenData = useRef<number[]>([0, 0]);

  const latestResetPositionRotationEvent = useRef<number>(0);
  const latestResetOnlyRotationEvent = useRef<number>(0);
  const leaveVenueRef = useRef<number>(0);

  const latestVenueModelConfigRef = useRef<VenueModelConfig | null>(null);

  const initAnimationRef = useRef("init");

  const isDisplayAvatarRef = useRef<boolean>(false);

  const isDisplayEnteringMaskRef = useRef<boolean>(false);
  const isDisplayLeavingMaskRef = useRef<boolean>(false);
  const isDisplayVenueNameRef = useRef<boolean>(false);

  const DataController = () => {
    const currentVenue = useExplorationStore((state) => state.currentVenue);
    useEffect(() => {
      console.log("init data " + currentVenue);
      if (!currentVenue) {
        return;
      }
      const venueName = getVenueNameByVenueCode(currentVenue);
      setCurrentVenueName(venueName);
      const venueModelConfig = getVenueModelConfigByVenueCode(currentVenue);
      setVenueModelConfigState(venueModelConfig);
      latestVenueModelConfigRef.current = venueModelConfig;
      setModelScaleFactorState(venueModelConfig.scaleFactor);

      moveSpeedRef.current = venueModelConfig.moveSpeed;
      rotateSpeedRef.current = venueModelConfig.rotateSpeed;
      downSpeedRef.current = venueModelConfig.downSpeed;

      if (venueModelConfig.floor) {
      }
      const floorNamelist = venueModelConfig.floor.map((f) => f.name);
      const topFloor = venueModelConfig.floor.reduce((maxFloor, floor) =>
        floor.index > maxFloor.index ? floor : maxFloor,
      );
      const defaultFloor = venueModelConfig.floor.find(
        (floor) => floor.index === venueModelConfig.defaultFloorIndex,
      );
      if (currentLevel == "") {
        setCurrentLevel(defaultFloor?.name ?? floorNamelist[0]);
      }
      topPositionRef.current = new pc.Vec3(
        venueModelConfig.defaultPosition[0] / venueModelConfig.scaleFactor,
        venueModelConfig.topAltitude / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[2] / venueModelConfig.scaleFactor + 3,
      );
      downPositionRef.current = new pc.Vec3(
        venueModelConfig.defaultPosition[0] / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[1] / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[2] / venueModelConfig.scaleFactor + 3,
      );
      backPositionRef.current = new pc.Vec3(
        venueModelConfig.defaultPosition[0] / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[1] / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[2] / venueModelConfig.scaleFactor - 3,
      );
      defaultPositionRef.current = new pc.Vec3(
        venueModelConfig.defaultPosition[0] / venueModelConfig.scaleFactor,
        (defaultFloor?.altitude ?? 0) / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[2] / venueModelConfig.scaleFactor,
      );
      defaultTargetRef.current = new pc.Vec3(
        venueModelConfig.defaultPosition[0] / venueModelConfig.scaleFactor,
        (defaultFloor?.altitude ?? 0) / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[2] / venueModelConfig.scaleFactor + 1,
      );
      setCoordReadyState(true);

      console.log(venueModelConfig.modelConfig);

      if (venueModelConfig && !venueModelConfig?.lod) {
        console.log("skip 3dGS !!!!");
        setModelLoadedState(true);
      }
    }, [currentVenue]);

    const cameraMode = useExplorationStore((state) => state.cameraMode);
    useEffect(() => {
      latestCameraModeRef.current = cameraMode;
    }, [cameraMode]);

    const xRayMode = useExplorationStore((state) => state.xRayMode);
    useEffect(() => {
      latestXrayModeRef.current = xRayMode;
      if (gsplatMainRef.current?.gsplat) {
        const opacity = xRayMode === 2 ? 0.05 : 1.0;
        gsplatMainRef.current.gsplat.setWorkBufferModifier({
          glsl: `
            void modifySplatCenter(inout vec3 center) {}
            void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {}
            void modifySplatColor(vec3 center, inout vec4 color) { color.a *= ${opacity.toFixed(1)}; }
          `,
        });
      }
    }, [xRayMode]);

    const currentLevel = useExplorationStore((state) => state.currentLevel);
    useEffect(() => {
      const venueModelConfig = getVenueModelConfigByVenueCode(currentVenue);
      latestCurrentLevelNameRef.current = currentLevel;
      const altitude = getAltitudeByFloorName(venueModelConfig, currentLevel);
      targetAltitudeRef.current = altitude / modelScaleFactorState;
      isLevelChangingRef.current = true;
      const levelIndex = getFloorIndexByFloorName(
        venueModelConfig,
        currentLevel,
      );
      setCurrentLevelIndex(levelIndex);
    }, [currentLevel]);

    const resetPositionRotationEvent = useExplorationStore(
      (state) => state.resetPositionRotationEvent,
    );
    useEffect(() => {
      latestResetPositionRotationEvent.current = resetPositionRotationEvent;
    }, [resetPositionRotationEvent]);

    const resetOnlyRotationEvent = useExplorationStore(
      (state) => state.resetOnlyRotationEvent,
    );
    useEffect(() => {
      latestResetOnlyRotationEvent.current = resetOnlyRotationEvent;
    }, [resetOnlyRotationEvent]);

    const leaveVenueEvent = useExplorationStore(
      (state) => state.leaveVenueEvent,
    );
    useEffect(() => {
      leaveVenueRef.current = leaveVenueEvent;
    }, [leaveVenueEvent]);

    const positionJoystickData = useExplorationStore(
      (state) => state.positionJoystickData,
    );
    const rotationJoystickData = useExplorationStore(
      (state) => state.rotationJoystickData,
    );

    useEffect(() => {
      latestPositionJoystickData.current = [
        positionJoystickData[0],
        positionJoystickData[1],
      ];
      trackGAEvent(EVENT.EXPLORE_JOYSTICK_INTERACTION, {
        mode: "exploration",
        currentVenue,
        type: "position",
      });
      trackEvent(AMPLITUDE_EVENT.EXPLORE_JOYSTICK_INTERACTION, {
        mode: "exploration",
        currentVenue,
        type: "position",
      });
    }, [positionJoystickData]);

    useEffect(() => {
      latestRotationJoystickData.current = [
        rotationJoystickData[0],
        rotationJoystickData[1],
      ];
      trackGAEvent(EVENT.EXPLORE_JOYSTICK_INTERACTION, {
        mode: "exploration",
        currentVenue,
        type: "rotation",
      });
      trackEvent(AMPLITUDE_EVENT.EXPLORE_JOYSTICK_INTERACTION, {
        mode: "exploration",
        currentVenue,
        type: "rotation",
      });
    }, [rotationJoystickData]);

    return <></>;
  };

  useEffect(() => {
    return () => {
      console.log("unmounting");
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
      if (revealEffectTimeoutRef.current) {
        clearTimeout(revealEffectTimeoutRef.current);
      }
      setIsDisplayUI(false);
    };
  }, []);

  useEffect(() => {
    console.log("modelLoadedState", modelLoadedState);
    console.log("coordReadyState", coordReadyState);
    if (!coordReadyState || !modelLoadedState) return;

    transitionTimeoutRef.current = setTimeout(() => {
      initAnimationRef.current = "goDown";
    }, 1000);
    revealEffectTimeoutRef.current = setTimeout(() => {
      isDisplayEnteringMaskRef.current = false;
      isDisplayVenueNameRef.current = true;
      if (gsplatMainRef.current) {
        gsplatMainRef.current.gsplat.enabled = true;
        createRadialScript();
      }
    }, 1000);
  }, [modelLoadedState, coordReadyState]);

  const FloorMeshContainer = () => {
    const baseUrl = getBaseUrl();
    const floorMeshPosition = venueModelConfigState.floorMeshPosition;
    const floorMeshUrl =
      baseUrl +
      venueModelConfigState!.folderPath +
      venueModelConfigState.floorMesh;
    return floorMeshUrl != "" ? (
      <FloorMesh
        floorMeshUrl={floorMeshUrl}
        floorMeshPosition={floorMeshPosition}
      />
    ) : (
      <></>
    );
  };

  const FloorMesh = ({
    floorMeshUrl,
    floorMeshPosition,
  }: {
    floorMeshUrl: string;
    floorMeshPosition: pc.Vec3;
  }) => {
    const floorMeshEntityRef = useRef();
    const { asset: floorMeshAsset } = useModel(floorMeshUrl);

    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(1, 1, 1);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };
    useEffect(() => {
      if (floorMeshAsset && floorMeshEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(floorMeshEntityRef.current);
        });
      }
    }, [floorMeshAsset]);

    return (
      <Entity
        ref={floorMeshEntityRef}
        rotation={[0, 180, 0]}
        position={[
          floorMeshPosition[0] / modelScaleFactorState,
          floorMeshPosition[1] / modelScaleFactorState,
          floorMeshPosition[2] / modelScaleFactorState,
        ]}
        scale={[
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
        ]}
      >
        <Render type="asset" asset={floorMeshAsset} />
      </Entity>
    );
  };

  const Avatar = () => {
    const app = useApp();
    const avatarEntityRef = useRef();
    let floatTime = 0;
    const _avatarPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const { asset: robot } = useModel(GLB_AVATAR);
    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(1, 1, 1);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };

    useEffect(() => {
      if (robot && avatarEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(avatarEntityRef.current);
        });
      }
    }, [robot]);

    const handleUpdate = useCallback((dt: number) => {
      floatTime += dt;
      if (avatarEntityRef.current) {
        _avatarPositionRef.current.set(0, Math.sin(floatTime * 2) * 0.05, 0);
        avatarEntityRef.current.setLocalPosition(_avatarPositionRef.current);
        avatarEntityRef.current.enabled =
          latestCameraModeRef.current == 1 || isDisplayAvatarRef.current;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return robot ? (
      <Entity position={[0, -1, 0]}>
        <Entity
          ref={avatarEntityRef}
          rotation={[10, 180, 0]}
          position={[0, 0, 0]}
          scale={[1, 1, 1]}
        >
          <Render type="asset" asset={robot} />
        </Entity>
      </Entity>
    ) : (
      <></>
    );
  };

  const MainCamera = () => {
    const app = useApp();
    let _localProgress;
    let _localCameraMode;
    let isCameraModeUpdated;
    let nearestFixedCameraPosition;

    let finalCameraPosition;
    let finalCameraLookingPosition;

    let goDownAnimationTime = 0;
    const goDownDuration = 3;

    let orbitAnimationTime = 0;
    const orbitDuration = 5;

    let zoomInAvatarAnimationTime = 0;
    const zoomInAvatarDuration = 1;

    let goUpAnimationTime = 0;
    const goUpDuration = 3;

    const handleUpdate = useCallback((dt: number) => {
      if (cameraScriptRef.current == null) {
        return;
      }

      isCameraModeUpdated = _localCameraMode != latestCameraModeRef.current;
      _localCameraMode = latestCameraModeRef.current;

      if (initAnimationRef.current == "init") {
        isDisplayEnteringMaskRef.current = true;
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          topPositionRef.current,
        );
        setCameraPosition(topPositionRef.current);
        setCameraLookingPosition(defaultTargetRef.current);
        const cameraAngle = getYAngleDegree(
          mainObjectEntityRef.current.getPosition(),
          defaultTargetRef.current,
        );
        setCameraAngle(cameraAngle);
      } else if (initAnimationRef.current == "goDown") {
        if (goDownAnimationTime >= goDownDuration) {
          cameraScriptRef.current.reset(
            mainObjectEntityRef.current.getPosition(),
            downPositionRef.current,
          );
          initAnimationRef.current = "orbit";
          return;
        }
        // if (goDownDuration - goDownAnimationTime < 1.5) {
        //   isDisplayEnteringMaskRef.current = false;
        // }
        goDownAnimationTime += dt;
        const t = Math.min(goDownAnimationTime / goDownDuration, 1);
        const newPos = new pc.Vec3().lerp(
          topPositionRef.current,
          downPositionRef.current,
          t,
        );
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPos,
        );
      } else if (initAnimationRef.current == "orbit") {
        if (orbitAnimationTime >= orbitDuration) {
          cameraScriptRef.current.reset(
            defaultTargetRef.current,
            mainObjectEntityRef.current.getPosition(),
          );
          initAnimationRef.current = "free";
          isDisplayAvatarRef.current = false;
          setIsDisplayUI(true);
          if (gsplatMainRef.current) {
            cleanup(app, gsplatMainRef.current);
          }
          return;
        }
        if (orbitAnimationTime + 1.5 >= orbitDuration) {
          isDisplayVenueNameRef.current = false;
        }
        orbitAnimationTime += dt;
        const t = Math.min(orbitAnimationTime / orbitDuration, 1);
        const newCameraPosition = interpolateVector3(initCameraMovement, t);
        const offsetLocal = new pc.Vec3(
          -newCameraPosition[0],
          newCameraPosition[1],
          -newCameraPosition[2],
        );
        const offsetWorld = mainObjectEntityRef.current
          .getRotation()
          .transformVector(offsetLocal);
        const newPos = mainObjectEntityRef.current
          .getPosition()
          .clone()
          .add(offsetWorld);
        cameraScriptRef.current.reset(defaultTargetRef.current, newPos);
      }
      // else if (initAnimationRef.current == "zoomInAvatar") {
      //   console.log("zoom in");
      //   if (zoomInAvatarAnimationTime >= zoomInAvatarDuration) {
      //     cameraScriptRef.current.reset(
      //       defaultTargetRef.current,
      //       mainObjectEntityRef.current.getPosition(),
      //     );
      //     initAnimationRef.current = "free";
      //     isDisplayAvatarRef.current = false;
      //     setIsDisplayUI(true);
      //     return;
      //   }
      //   zoomInAvatarAnimationTime += dt;
      //   const t = Math.min(zoomInAvatarAnimationTime / zoomInAvatarDuration, 1);
      //   const newPos = new pc.Vec3().lerp(
      //     backPositionRef.current,
      //     mainObjectEntityRef.current.getPosition(),
      //     t,
      //   );
      //   cameraScriptRef.current.reset(defaultTargetRef.current, newPos);
      // }
      else if (initAnimationRef.current == "free") {
        const newPosition =
          latestCameraModeRef.current == 0
            ? firstPersonCameraEntityRef.current.getPosition()
            : thirdPersonCameraEntityRef.current.getPosition();
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPosition,
        );

        isMovingRef.current = false;
        isRotatingRef.current = false;

        setCameraPosition(newPosition);
        setCameraLookingPosition(mainObjectEntityRef.current.getPosition());
        const cameraAngle = getYAngleDegree(
          newPosition,
          mainObjectEntityRef.current.getPosition(),
        );
        setCameraAngle(cameraAngle);
      } else if (initAnimationRef.current == "ending") {
        isDisplayAvatarRef.current = true;
        setIsDisplayUI(false);
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          downPositionRef.current,
        );

        if (goUpAnimationTime >= goUpDuration) {
          cameraScriptRef.current.reset(
            mainObjectEntityRef.current.getPosition(),
            upPositionRef.current,
          );
          return;
        }
        if (goUpAnimationTime > 0.5) {
          isDisplayLeavingMaskRef.current = true;
        }
        goUpAnimationTime += dt;
        const t = Math.min(goUpAnimationTime / goUpDuration, 1);
        const newPos = new pc.Vec3().lerp(
          downPositionRef.current,
          topPositionRef.current,
          t,
        );
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPos,
        );
      }

      // if (
      //   initAnimationRef.current != "free" ||
      //   isCameraModeUpdated ||
      //   isMovingRef.current ||
      //   isRotatingRef.current
      // ) {
      //   const newPosition =
      //     latestCameraModeRef.current == 0
      //       ? firstPersonCameraEntityRef.current.getPosition()
      //       : thirdPersonCameraEntityRef.current.getPosition();
      //   cameraScriptRef.current.reset(
      //     mainObjectEntityRef.current.getPosition(),
      //     newPosition,
      //   );

      //   isMovingRef.current = false;
      //   isRotatingRef.current = false;

      //   setCameraPosition(newPosition);
      //   setCameraLookingPosition(mainObjectEntityRef.current.getPosition());
      //   const cameraAngle = getYAngleDegree(
      //     newPosition,
      //     mainObjectEntityRef.current.getPosition(),
      //   );
      //   setCameraAngle(cameraAngle);
      // }
    }, []);
    useAppEvent("update", handleUpdate);

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState,
      );
      const defaultPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState - 1,
      );
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
    }, []);

    return (
      <Entity>
        <Camera fov={60} />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
        // enableFly={false}
        />
        <Entity ref={hiddenNearRef} position={[0, 0, 0]}></Entity>
        <Entity ref={hiddenFarRef} position={[0, 0, -0.5]}></Entity>
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();

    let goDownAnimationTime = 0;
    const goDownDuration = 3;

    let goUpAnimationTime = 0;
    const goUpDuration = 2;

    const eulerRef = useRef(new pc.Vec3(0, 180, 0));
    let _localResetPositionRotationEvent = 0;
    let _localResetOnlyRotationEvent = 0;
    let _localLeaveVenueEvent = 0;
    let temp = false;

    useEffect(() => {
      mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
    }, []);

    const handleUpdate = useCallback((dt: number) => {
      if (mainObjectEntityRef.current == null) {
        return;
      }
      let isResetPositionRotation =
        _localResetPositionRotationEvent !=
        latestResetPositionRotationEvent.current;
      _localResetPositionRotationEvent =
        latestResetPositionRotationEvent.current;
      let isResetOnlyRotation =
        _localResetOnlyRotationEvent != latestResetOnlyRotationEvent.current;
      _localResetOnlyRotationEvent = latestResetOnlyRotationEvent.current;

      let isLeaveVenue = _localLeaveVenueEvent != leaveVenueRef.current;
      _localLeaveVenueEvent = leaveVenueRef.current;

      if (initAnimationRef.current == "init") {
        isDisplayAvatarRef.current = true;
        mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
        mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
      } else if (initAnimationRef.current == "free") {
        if (latestPositionJoystickData.current.length != 2) {
          return;
        }

        if (isLevelChangingRef.current) {
          isMovingRef.current = true;
          const targetPosition = new pc.Vec3(
            mainObjectEntityRef.current.getPosition().x,
            targetAltitudeRef.current,
            mainObjectEntityRef.current.getPosition().z,
          );
          const distance = vec3Distance(
            mainObjectEntityRef.current.getPosition(),
            targetPosition,
          );
          const positionAlpha = Math.min(1, (3 * dt) / distance);
          mainObjectEntityRef.current.setPosition(targetPosition);
          isLevelChangingRef.current = false;
        }

        if (
          latestPositionJoystickData.current[0] != 0 ||
          latestPositionJoystickData.current[1] != 0
        ) {
          isMovingRef.current = true;
          const worldMat = mainObjectEntityRef.current.getWorldTransform();
          const forward = new pc.Vec3(0, 0, -1);
          worldMat.transformVector(forward, forward);
          forward.y = 0;
          forward.normalize();
          const up = pc.Vec3.UP.clone();
          const right = new pc.Vec3();
          right.cross(up, forward).normalize();
          const forwardScale =
            latestPositionJoystickData.current[1] * moveSpeedRef.current * -dt;
          const rightScale =
            latestPositionJoystickData.current[0] * moveSpeedRef.current * -dt;
          const forwardMove = forward.clone().mulScalar(forwardScale);
          const rightMove = right.clone().mulScalar(rightScale);
          const move = new pc.Vec3();
          move.add(forwardMove).add(rightMove);
          mainObjectEntityRef.current.translate(move);
        }

        if (
          latestRotationJoystickData.current[0] != 0 ||
          latestRotationJoystickData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationJoystickData.current[0] *
            rotateSpeedRef.current *
            dt; // Yaw
          eulerRef.current.x +=
            -latestRotationJoystickData.current[1] *
            rotateSpeedRef.current *
            dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }

        if (
          latestRotationScreenData.current[0] != 0 ||
          latestRotationScreenData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationScreenData.current[0] * rotateSpeedRef.current * dt; // Yaw
          eulerRef.current.x +=
            -latestRotationScreenData.current[1] * rotateSpeedRef.current * dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }

        // handle reset
        if (isResetPositionRotation) {
          isMovingRef.current = true;
          isRotatingRef.current = true;
          mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
        }
        if (isResetOnlyRotation) {
          isRotatingRef.current = true;
          eulerRef.current.x = 0;
          mainObjectEntityRef.current.setLocalEulerAngles(
            eulerRef.current.x,
            eulerRef.current.y,
            eulerRef.current.z,
          );
        }
        if (isLeaveVenue) {
          mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
          initAnimationRef.current = "ending";
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={mainObjectEntityRef}>
        <Avatar />
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.5]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.5, 4]}
        ></Entity>
      </Entity>
    );
  };

  const installCameraNearFar = (
    app: pc.Application,
    gsplatEntity: pc.Entity,
  ) => {
    const device = app.graphicsDevice;
    const gsplatMat =
      app.scene.gsplat.material || gsplatEntity.gsplat?.material;
    if (!gsplatMat) return () => { };

    if (!hiddenNearRef.current || !hiddenFarRef.current) {
      return () => { };
    }

    const glsl = `
      uniform vec3 uCutA;       // camera position in WORLD space
      uniform vec3 uCutB;       // robot position in WORLD space
      uniform float uCutRadius; // cylinder radius of the cutaway
      uniform float uCutFeather;// soft edge transition distance

      // Calculate the shortest distance from a point (p) to a line segment (a to b)
      float segDist(vec3 p, vec3 a, vec3 b) {
        vec3 pa = p - a;
        vec3 ba = b - a;
        float h = clamp(dot(pa, ba) / max(dot(ba, ba), 1e-6), 0.0, 1.0);
        return length(pa - ba * h);
      }

      void modifySplatCenter(inout vec3 center) {
      }

      void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {
        // Calculate distance between current splat and the Camera-Robot line segment
        float d = segDist(originalCenter, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);

        // Scale down splats that are too close to the line to 0, making them disappear
        scale *= alpha;
      }

      void modifySplatColor(vec3 center, inout vec4 color) {
        // Apply the same transition to the alpha channel as a double-safeguard
        float d = segDist(center, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);
        color.a *= alpha;
      }
    `;

    gsplatMat.getShaderChunks("glsl").set("gsplatModifyVS", glsl);
    gsplatMat.update();

    const uCutA = device.scope.resolve("uCutA");
    const uCutB = device.scope.resolve("uCutB");
    const uCutRadius = device.scope.resolve("uCutRadius");
    const uCutFeather = device.scope.resolve("uCutFeather");
    uCutRadius.setValue(1);
    uCutFeather.setValue(0.01);

    const onUpdate = () => {
      if (!hiddenNearRef.current || !hiddenFarRef.current) {
        return;
      }
      const nearPosition = hiddenNearRef.current.getPosition().clone();
      const farPosition = hiddenFarRef.current.getPosition().clone();
      if (nearPosition.length() === 0 || isNaN(nearPosition.x)) return;
      const dirToCamera = new pc.Vec3().sub2(nearPosition, farPosition);
      const totalDist = dirToCamera.length();
      dirToCamera.normalize();
      uCutA.setValue([nearPosition.x, nearPosition.y, nearPosition.z]);
      uCutB.setValue([farPosition.x, farPosition.y, farPosition.z]);
    };
    app.on("update", onUpdate);
    return () => app.off("update", onUpdate);
  };

  const createRadialScript = () => {
    const revealSpped = venueModelConfigState.revealSpeed ?? 10;
    const mainObjectPosition = mainObjectEntityRef.current.getPosition();
    console.log(mainObjectPosition);
    const script = gsplatMainRef.current.script?.create(GsplatRevealRadial);
    if (script) {
      script.center.set(
        mainObjectPosition.x,
        mainObjectPosition.y,
        mainObjectPosition.z,
      );
      script.speed = revealSpped;
      script.acceleration = 0;
      script.delay = 1.2;
      script.dotTint.set(0, 1, 1); // Cyan
      script.waveTint.set(0, 1, 0); // Orange
      script.oscillationIntensity = 1;
      script.endRadius = 10000;
    }
    return script;
  };

  const cleanup = (app, gsplatEntity) => {
    const cleanup = installCameraNearFar(app, gsplatEntity);
    return cleanup;
  };

  const VenueLod = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    // const { asset, loading, error, lodDistances, subscribe } = useLodSplat(
    //   venueModelConfigState!.baseUrl + venueModelConfigState!.lod,
    // );f
    const { asset, loading, error, lodDistances, subscribe } = useLodSplat(
      baseUrl + venueModelConfigState!.folderPath + venueModelConfigState!.lod,
    );
    useEffect(() => {
      if (!asset) {
        return;
      }
      const gsplatEntity = gsplatMainRef.current;
      console.log(gsplatEntity);
      if (!gsplatEntity || !app) return;
      gsplatEntity.gsplat.enabled = false;
      gsplatEntity.gsplat.unified = true;
      gsplatEntity.gsplat.asset = asset;
      gsplatEntity.gsplat.lodDistances = [
        20 * modelScaleFactorState,
        100 * modelScaleFactorState,
        500 * modelScaleFactorState,
      ];
      //gsplatEntity.gsplat.enabled = true;
      //app.scene.gsplat.colorizeLod = true;
      setModelLoadedState(true);
      enableXRayMode();
      gsplatEntity.addComponent("script");
    }, [asset]);

    return (
      <Entity
        ref={gsplatMainRef}
        rotation={[180, 0, 0]}
        position={[0, 0, 0]}
        scale={[
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
        ]}
      >
        <GSplat />
      </Entity>
    );
  };

  const TempPoi = ({ imageUrl, position, rotation }) => {
    const app = useApp();
    const frontRef = useRef(null);
    const backRef = useRef(null);
    const floatingEntityRef = useRef(null);

    const whiteMaterial = useMaterial({
      emissive: [1, 1, 1],
      emissiveIntensity: 2,
    });

    useEffect(() => {
      if (!app) return;
      const textureAsset = new pc.Asset("myTexture", "texture", {
        url: imageUrl,
      });
      app.assets.add(textureAsset);
      app.assets.load(textureAsset);
      textureAsset.on("load", () => {
        [frontRef.current, backRef.current].forEach((entity, i) => {
          if (entity?.render?.material) {
            entity.render.material.emissiveMap = textureAsset.resource; // Self-lit texture
            entity.render.material.emissiveIntensity = 1.2;
            entity.render.material.emissiveTint = [1, 1, 1, 1];
            entity.render.material.update();
          }
        });
      });
      let time = 0;
      const originalY = 1;
      function updateFloating(dt) {
        time += dt;
        if (floatingEntityRef.current) {
          const floatOffset = Math.sin(time * 2) * 0.3; // Up/down only
          floatingEntityRef.current.setLocalPosition(
            0,
            originalY + floatOffset,
            0,
          );
        }
      }
      app.on("update", updateFloating);
      return () => {
        app.off("update", updateFloating);
      };
    }, [app]);

    return (
      <Entity position={position} scale={[0.8, 0.8, 0.8]} rotation={rotation}>
        <Entity ref={floatingEntityRef}>
          <Entity rotation={[90, 0, 0]} ref={frontRef}>
            <Render type="plane" material={whiteMaterial} />
          </Entity>
          <Entity rotation={[90, 180, 0]} ref={backRef}>
            <Render type="plane" material={whiteMaterial} />
          </Entity>
        </Entity>
      </Entity>
    );
  };

  const CirclePoi = ({ colorHex, textureUrl, position, rotation }) => {
    const app = useApp();
    const entityRef = useRef();
    const floatingEntityRef = useRef(null);

    let floatTime = 0;
    const _avatarPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const { asset: model } = useModel(
      "https://assets.deepworldmodel.ai/poi_model/circle_poi.glb",
    );
    console.log("load texture url " + textureUrl);
    const { asset: newTextureAsset } = useTexture(textureUrl);

    useEffect(() => {
      if (!app) return;
      let time = 0;
      const originalY = 1;
      function updateFloating(dt) {
        time += dt;
        if (floatingEntityRef.current) {
          const floatOffset = Math.sin(time * 2) * 0.2; // Up/down only
          floatingEntityRef.current.setLocalPosition(
            0,
            originalY + floatOffset,
            0,
          );
        }
      }
      app.on("update", updateFloating);
      return () => {
        app.off("update", updateFloating);
      };
    }, [app]);

    const changeMaterial = (entity) => {
      console.log("change material");
      console.log(newTextureAsset);
      if (entity == null || newTextureAsset == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material.clone();
            if (material) {
              if (material.name === "color") {
                // For "color" material: pure emissive tint (no texture needed)
                material.emissiveMap = null;
                material.emissiveIntensity = 1.0;
                const newColor = hexToRgbArray(colorHex);
                material.emissive = new pc.Color(
                  newColor[0],
                  newColor[1],
                  newColor[2],
                ); // Custom pinkish tint - adjust RGB as needed
                material.diffuse = new pc.Color(
                  newColor[0],
                  newColor[1],
                  newColor[2],
                ); // Fallback tint
                material.useLighting = false;
              } else if (material.name === "texture") {
                // Load new texture if available, otherwise keep existing
                if (newTextureAsset?.resource) {
                  material.diffuseMap = newTextureAsset.resource;
                  material.emissiveMap = newTextureAsset.resource; // Also use as emissive
                }
                material.emissiveIntensity = 1.2;
                material.emissive = new pc.Color(1, 1, 1);
                material.useLighting = false;
              }
              material.update();
              meshInstance.material = material;
            }
          });
        }
      });
    };

    useEffect(() => {
      if (model && entityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(entityRef.current);
        });
      }
    }, [model, newTextureAsset]);

    return model ? (
      <Entity position={position} rotation={rotation}>
        <Entity ref={floatingEntityRef}>
          <Entity ref={entityRef} scale={[0.4, 0.4, 0.4]}>
            <Render type="asset" asset={model} />
          </Entity>
        </Entity>
      </Entity>
    ) : (
      <></>
    );
  };

  const TestingPois = () => {
    return (
      <>
        {venueModelConfigState!.testingPois.map((item, index) => (
          <CirclePoi
            key={item.key}
            colorHex={item.colorHex}
            textureUrl={item.textureUrl}
            position={item.position}
            rotation={item.rotation}
          />
        ))}
      </>
    );
  };

  const MeshModels = () => {
    const baseUrl = getBaseUrl();
    return (
      <>
        {venueModelConfigState!.mesh.meshModels.map((item, index) => (
          <Fragment key={item.index}>
            <MeshModel
              meshUrl={baseUrl + venueModelConfigState!.folderPath + item.url}
              meshPosition={item.position}
              meshRotationAngle={item.rotationAngle}
              meshScale={item.scale}
              meshColor={item.color ?? "#FFFFFF"}
              meshOpacity={item.opacity ?? 1}
              rotateObjects={item.rotateObjects ?? []}
            />
          </Fragment>
        ))}
      </>
    );
  };

  const MeshModel = ({
    meshUrl,
    meshPosition,
    meshRotationAngle,
    meshScale,
    meshColor,
    meshOpacity,
    rotateObjects,
  }: {
    meshUrl: string;
    meshPosition: number[];
    meshRotationAngle: number[];
    meshScale: number[];
    meshColor: string;
    meshOpacity: number;
    rotateObjects: string[];
  }) => {
    const app = useApp();
    const meshEntityRef = useRef();
    const { asset: meshAsset } = useModel(meshUrl);
    //const { asset: meshAsset } = useModel("http:assets.deepworldmodel.ai/venue/floor_mesh/wksFloor_20260113_1800.glb");
    const color = hexToRgbArray(meshColor);

    const handleUpdate = useCallback((dt: number) => {
      rotateObjects.forEach((eachObject) => {
        const childEntity = meshEntityRef.current.findByName(eachObject);
        if (childEntity) {
          const rotationY = getYAngleDegree(
            childEntity.getPosition(),
            cameraScriptRef.current.entity.getPosition(),
          );
          childEntity.setEulerAngles(0, -rotationY, 0);
        }
      });
    }, []);
    useAppEvent("update", handleUpdate);

    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(color[0], color[1], color[2]);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };
    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(meshEntityRef.current);
        });
      }
    }, [meshAsset]);

    return (
      <Entity
        ref={meshEntityRef}
        position={[
          meshPosition[0] / modelScaleFactorState,
          meshPosition[1] / modelScaleFactorState,
          meshPosition[2] / modelScaleFactorState,
        ]}
        rotation={meshRotationAngle}
        scale={[
          meshScale[0] / modelScaleFactorState,
          meshScale[1] / modelScaleFactorState,
          meshScale[2] / modelScaleFactorState,
        ]}
      >
        <Render type="asset" asset={meshAsset} />
      </Entity>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    return (
      <>
        {/*<SimpleModel/>*/}
        {venueModelConfigState!.lod ? <VenueLod /> : <></>}
        {venueModelConfigState!.testingPois ? <TestingPois /> : <></>}
        {venueModelConfigState!.mesh ? <MeshModels /> : <></>}
        {venueModelConfigState!.floorMesh ? <FloorMeshContainer /> : <></>}
        {venueModelConfigState ? (
          <>
            <MainObject />
            <MainCamera />
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  const Scene = () => {
    return (
      <Application>
        {venueModelConfigState != null && modelScaleFactorState > 0 ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  const DragController = () => {
    const currentVenue = useExplorationStore((state) => state.currentVenue);
    const isDraggingRef = useRef(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const previousPositionRef = useRef({ x: 0, y: 0 });
    const getClientPos = (e) => {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    };
    const handleStart = useCallback((e) => {
      const pos = getClientPos(e);
      isDraggingRef.current = true;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      trackGAEvent(EVENT.EXPLORE_INTERACTION, {
        mode: "exploration",
        currentVenue,
      });
      trackEvent(AMPLITUDE_EVENT.EXPLORE_INTERACTION, {
        mode: "exploration",
        currentVenue,
      });
    }, []);
    const handleMove = useCallback((e) => {
      if (!isDraggingRef.current) {
        return;
      }
      const pos = getClientPos(e);
      const xChange = pos.x - previousPositionRef.current.x;
      const yChange = pos.y - previousPositionRef.current.y;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      latestRotationScreenData.current[0] = xChange * 0.5;
      latestRotationScreenData.current[1] = yChange * 0.5;
    }, []);
    const handleEnd = useCallback(() => {
      isDraggingRef.current = false;
      latestRotationScreenData.current[0] = 0;
      latestRotationScreenData.current[1] = 0;
    }, []);
    useEffect(() => {
      window.addEventListener("mouseup", handleEnd);
      window.addEventListener("touchend", handleEnd);
      return () => {
        window.removeEventListener("mouseup", handleEnd);
        window.removeEventListener("touchend", handleEnd);
      };
    }, []);

    return (
      <div
        className="fullscreen_div"
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseUp={handleEnd}
        onTouchEnd={handleEnd}
      ></div>
    );
  };

  const EnterLoading = () => {
    const [isDisplayMask, setIsDisplayMask] = useState<boolean>(true);
    const opacityRef = useRef<number>(1);
    const divRef = useRef<HTMLDivElement>(null);
    const EACH_OPACITY = 0.02;
    const animationRef = useRef<number>(0);
    const keepCheckLoading = () => {
      if (!isDisplayEnteringMaskRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      setIsDisplayMask(opacityRef.current > 0);

      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return isDisplayMask ? (
      <div
        ref={divRef}
        className={`fullscreen_div flex items-center justify-center z-[60]`}
      >
        <div className="fullscreen_div bg-[#FFFFFF99] backdrop-blur-md"></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const LeaveLoading = () => {
    const [isDisplayMask, setIsDisplayMask] = useState<boolean>(false);
    const opacityRef = useRef<number>(0);
    const divRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<number>(0);
    const EACH_OPACITY = 0.02;
    const keepCheckLoading = () => {
      if (!isDisplayLeavingMaskRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      setIsDisplayMask(opacityRef.current > 0);

      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return isDisplayMask ? (
      <div
        ref={divRef}
        className={`fullscreen_div flex items-center justify-center z-[60]`}
      >
        <div className="fullscreen_div bg-[#FFFFFF99] backdrop-blur-md"></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const VenueName = () => {
    const divRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<number>(0);
    const opacityRef = useRef<number>(0);
    const EACH_OPACITY = 0.02;
    const keepCheckLoading = () => {
      if (!isDisplayVenueNameRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    const venueName = useExplorationStore((state) => state.currentVenueName);
    return (
      <div
        ref={divRef}
        className={`fullscreen_div flex flex-col items-center justify-center pointer-events-none`}
      >
        <div>
          <Image src="/assets/icon_map_pin.png" height={60} width={60} />
        </div>
        <div
          className={`text-[#E5E9EDE5] font-extrabold text-[46px] text-center`}
        >
          {venueName.toUpperCase()}
        </div>
      </div>
    );
  };

  console.log(
    "ExplorationPage component rendered , if this keep showing, something wrong",
  );

  return (
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{ backgroundColor: "black" }}
    >
      <DataController />
      <Scene />
      <DragController />
      <EnterLoading />
      <LeaveLoading />
      <VenueName />
      <WatermarkScreen />
    </div>
  );
}
